import { ActionTypes } from "../constants/action-types";

const initialState = {
    JudgeImageStaus:[],
};

export const UploadJudgeImage = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.UPLOAD_JUDGE_IMAGE:
      return { ...state, JudgeImageStaus: payload };
    default:
      return state;
  }
};